import * as React from 'react';
import Loader from '../_common/loader';

const DatasetNotebookContainer = React.lazy(() => import('../dataset-section-components/dataset-notebook'));

const datasetNotebookSection = function DatasetNotebookSection({
    isBundle,
    isLoggedIn,
    scrollTo,
    dataSectionType,
    dataNotebooks,
    solutionurl
}: DatasetNotebookSectionProps) {
    return (
        <section id={dataSectionType} className="dataset-data-section page-section">
            <React.Suspense fallback={<Loader minHeight="700px" />}>
                <DatasetNotebookContainer isLoggedIn={isLoggedIn} isBundle={isBundle} scrollTo={scrollTo} dataSectionType={dataSectionType} dataNotebooks={dataNotebooks} solutionurl={solutionurl} />
            </React.Suspense>
        </section>
    );
};

export default React.memo(datasetNotebookSection);
